// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBy":"styles_sponsoredBy__KNo8b","icon":"styles_icon__XJvuR","logo":"styles_logo__K5fly"};